import useTabParam from '../../hooks/useTabParam';

/**
 * The card page's tabs, in the URL.
 *
 * `/cards/:id` is the card's read-only HOME; `?tab=` selects an editing
 * domain over the same draft. The convention is every tabbed page's, and it
 * lives in one place, hooks/useTabParam (KPR-1579): the default tab's param is
 * DELETED rather than written, every change is `replace: true` so the tabs do
 * not stack up in the back button, and a `?tab=` naming a tab this viewer does
 * not have falls back to the default instead of rendering nothing.
 */
export const CARD_TAB = Object.freeze({
	overview: 'overview',
	basics: 'basics',
	elements: 'elements',
	display: 'display',
	danger: 'danger',
});

export const CARD_TAB_LABELS = Object.freeze({
	overview: 'Overview',
	basics: 'Basics',
	elements: 'Elements',
	display: 'Display',
	danger: 'Danger zone',
});

/** The tabs an editing draft touches — Overview shows the saved card. */
export const EDITING_TABS = Object.freeze([CARD_TAB.basics, CARD_TAB.elements, CARD_TAB.display]);

/**
 * `[activeKey, setTab]` for the tab keys this viewer actually has.
 *
 * `defaultKey` is the tab the bare route shows: the home for a saved card,
 * Basics for a new one (a home needs a saved record).
 */
export function useCardTab(keys = [], defaultKey = CARD_TAB.overview) {
	return useTabParam(keys, defaultKey);
}
